import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

export interface BrandProps {
  /** When set, the brand glyph + wordmark links here. Default `/`. */
  to?: string;
}

/** Brand mark — replicates the DEMO topbar's "Q · Quiet Letters" pairing.
 *  Pure presentational; no auth state. */
export function Brand({ to = '/' }: BrandProps): ReactNode {
  return (
    <Link
      to={to}
      aria-label="Personal Blog"
      className="topbar-brand inline-flex items-center gap-2.5 transition-opacity hover:opacity-80"
      style={{ color: 'var(--vq-ink)', textDecoration: 'none' }}
    >
      <span
        aria-hidden
        className="inline-flex h-8 w-8 items-center justify-center font-serif text-base italic"
        style={{
          backgroundColor: 'var(--vq-ink)',
          color: 'var(--vq-paper-raised)',
          borderRadius: 'var(--vq-radius-pill)',
        }}
      >
        P
      </span>
      <span
        className="topbar-brand__wordmark truncate font-serif text-lg font-medium tracking-tight"
        style={{ color: 'var(--vq-ink)' }}
      >
        Personal Blog
      </span>
    </Link>
  );
}
